'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph) {
    return _react2.default.createElement(
      'p',
      { className: 'faq-content__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderHatchLink = function renderHatchLink(link) {
  if (link && link.text) {
    var linkTarget = void 0;
    if (link.target) {
      linkTarget = '' + link.target;
    }
    return _react2.default.createElement(
      'a',
      { id: link.id, href: link.href, target: linkTarget, className: 'faq-content__link' },
      link.text
    );
  }
  return null;
};

var FaqContent = function FaqContent(props) {
  var _props$content = props.content,
      paragraph = _props$content.paragraph,
      link = _props$content.link;


  var moleculeClasses = (0, _classnames2.default)('faq-content', props.className);

  return _react2.default.createElement(
    'div',
    { className: moleculeClasses },
    renderParagraph(paragraph),
    renderHatchLink(link)
  );
};

exports.default = FaqContent;


FaqContent.propTypes = {
  content: _propTypes2.default.shape({
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    link: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string,
      text: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    })
  }),
  className: _propTypes2.default.string
};

FaqContent.defaultProps = {
  content: {
    paragraph: {
      text: '300 characters maximum is recommended to minimize scrolling in a mobile view.'
    },
    link: {
      id: '',
      href: '#',
      text: '34 characters maximum per line',
      target: '_blank'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/faq-content/jsx/FaqContent.js
// module id = 662
// module chunks = 4